import { ArrowUp } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="border-t border-white/10" data-testid="site-footer">
      <div className="mx-auto flex max-w-[1440px] flex-col items-start justify-between gap-8 px-6 py-12 md:flex-row md:items-center md:px-12">
        <a href="#top" className="group flex items-center" data-testid="footer-logo">
          <img src="/assets/logo-white.png" alt="Payung Oren Creative" className="h-8 w-auto" />
        </a>
        <div className="flex flex-col gap-2">
          <p className="font-spacemono text-[10px] uppercase tracking-[0.3em] text-white/35">
            {t("footer.copyright")}
          </p>
          <p className="font-spacemono text-[10px] uppercase tracking-[0.3em] text-white/25">
            {t("footer.entities")}
          </p>
        </div>
        <a
          href="#top"
          className="group flex items-center gap-3 font-spacemono text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 hover:text-white"
          data-testid="footer-back-to-top"
        >
          {t("footer.backToTop")}
          <span className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 transition-colors duration-300 group-hover:border-[#F97316] group-hover:bg-[#F97316]">
            <ArrowUp className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5" />
          </span>
        </a>
      </div>
    </footer>
  );
}
